import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { useLanguage } from '../context/LanguageContext';

const CookiePolicyPage = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen">
      <Header />
      
      <section className="py-16 md:py-24 bg-white">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="font-montserrat-bold text-3xl md:text-4xl text-[#0b004c] mb-8 text-center">
            {t('cookieTitle')}
          </h1>
          
          <div className="prose prose-lg max-w-none font-montserrat text-[#6a6a6a]">
            <p className="mb-6">
              <strong>{t('lastUpdated')}</strong> {t('january2025')}
            </p>

            <h2 className="font-montserrat-bold text-xl text-[#0b004c] mt-8 mb-4">{t('cookieWhatTitle')}</h2>
            <p className="mb-4">
              {t('cookieWhatContent')}
            </p>

            <h2 className="font-montserrat-bold text-xl text-[#0b004c] mt-8 mb-4">{t('cookieHowTitle')}</h2>
            <p className="mb-4">{t('cookieHowIntro')}</p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li><strong>{t('cookieEssential')}</strong> {t('cookieEssentialDesc')}</li>
              <li><strong>{t('cookieAnalytics')}</strong> {t('cookieAnalyticsDesc')}</li>
              <li><strong>{t('cookieFunctional')}</strong> {t('cookieFunctionalDesc')}</li>
              <li><strong>{t('cookieMarketing')}</strong> {t('cookieMarketingDesc')}</li>
            </ul>

            <h2 className="font-montserrat-bold text-xl text-[#0b004c] mt-8 mb-4">{t('cookieTypesTitle')}</h2>
            
            <h3 className="font-montserrat-bold text-lg text-[#0b004c] mt-6 mb-3">{t('cookieEssentialTitle')}</h3>
            <p className="mb-4">
              {t('cookieEssentialContent')}
            </p>

            <h3 className="font-montserrat-bold text-lg text-[#0b004c] mt-6 mb-3">{t('cookieAnalyticsTitle')}</h3>
            <p className="mb-4">
              {t('cookieAnalyticsContent')}
            </p>

            <h3 className="font-montserrat-bold text-lg text-[#0b004c] mt-6 mb-3">{t('cookieThirdPartyTitle')}</h3>
            <p className="mb-4">
              {t('cookieThirdPartyContent')}
            </p>

            <h2 className="font-montserrat-bold text-xl text-[#0b004c] mt-8 mb-4">{t('cookieManagingTitle')}</h2>
            <p className="mb-4">
              {t('cookieManagingContent')}
            </p>

            <h2 className="font-montserrat-bold text-xl text-[#0b004c] mt-8 mb-4">{t('cookieBrowserTitle')}</h2>
            <p className="mb-4">{t('cookieBrowserIntro')}</p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li><strong>Chrome:</strong> Settings → Privacy and security → Cookies</li>
              <li><strong>Firefox:</strong> Options → Privacy & Security → Cookies</li>
              <li><strong>Safari:</strong> Preferences → Privacy → Cookies</li>
              <li><strong>Edge:</strong> Settings → Cookies and site permissions</li>
            </ul>

            <h2 className="font-montserrat-bold text-xl text-[#0b004c] mt-8 mb-4">{t('cookieUpdatesTitle')}</h2>
            <p className="mb-4">
              {t('cookieUpdatesContent')}
            </p>

            <h2 className="font-montserrat-bold text-xl text-[#0b004c] mt-8 mb-4">{t('cookieContactTitle')}</h2>
            <p className="mb-4">
              {t('cookieContactContent')}
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CookiePolicyPage;
